import CharacterCurtain from "@/pages/home/components/CharacterCurtain";

export default function Home() {
  return (
    <div
      className="relative w-full min-h-screen overflow-hidden bg-cover bg-no-repeat"
      style={{
        backgroundImage:
          "url('https://static.readdy.ai/image/ef1aae41220ad17a1705abffff22a58b/6c43a8a60e92a4aff91591bda9b5454e.png')",
        backgroundPosition: "center -6vh",
        color: "#2a1f14",
      }}
    >
      {/* top navigation */}
      <header className="absolute inset-x-0 z-40 flex items-center justify-between px-12 py-8" style={{ top: "1vh" }}>
        <div className="flex items-center gap-12">
          <a
            href="#"
            className="font-display text-[24px] font-semibold tracking-tight"
            style={{ color: "#2a1f14" }}
          >
            Halcyone
          </a>
          <nav className="hidden md:flex items-center gap-9 font-mono-ui text-[15px] tracking-[0.18em]">
            <a href="#" className="cursor-pointer" style={{ color: "#2a1f14" }}>
              Home
            </a>
            <a
              href="#"
              className="cursor-pointer"
              style={{ color: "#4a3728" }}
            >
              Destinations
            </a>
            <a
              href="#"
              className="cursor-pointer"
              style={{ color: "#4a3728" }}
            >
              Community
            </a>
          </nav>
        </div>
        <button
          type="button"
          className="whitespace-nowrap cursor-pointer rounded-md px-6 py-3 font-mono-ui text-[15px] tracking-[0.18em]"
          style={{ backgroundColor: "#2a1f14", color: "#efe6d3" }}
        >
          Configure
        </button>
      </header>

      {/* curtain hangs from right below the hat brim */}
      <div
        className="absolute z-10 flex flex-col items-center"
        style={{ top: "40vh", left: "18vw" }}
      >
        <div className="w-[60vw] min-w-[640px] h-[80vh] min-h-[640px]">
          <CharacterCurtain />
        </div>
      </div>

      {/* hat overlay on the very top layer, aligned over the background hat */}
      <img
        src="https://storage.readdy-site.link/project_files/0d241433-7b32-408d-86cc-543976aa2402/353e9eae-9894-4c38-8511-86a5d7eafd9f_compressed_unnamed.webp"
        alt="hat"
        className="pointer-events-none absolute z-30 select-none"
        style={{
          top: "calc(-2vh + 40px)",
          left: "50%",
          transform: "translateX(calc(-50% - 2vw - 7px))",
          width: "60vw",
          minWidth: "760px",
          height: "auto",
        }}
      />

      {/* editorial hero title - left half (moved to bottom-left) */}
      <div
        className="absolute z-40"
        style={{ left: "3vw", bottom: "10vh", maxWidth: "26vw", minWidth: "300px" }}
      >
        <p
          className="mb-6 font-mono-ui text-[12px] tracking-[0.2em]"
          style={{ color: "#4a3728" }}
        >
          The crown of felt
        </p>
        <h1
          className="font-display font-normal"
          style={{
            color: "#2a1f14",
            fontSize: "clamp(48px, 6vw, 88px)",
            lineHeight: 0.98,
            letterSpacing: "-0.02em",
          }}
        >
          Under&nbsp;
          <span
            aria-hidden="true"
            className="inline-block align-middle"
            style={{
              width: "0.7em",
              height: "0.06em",
              backgroundColor: "#2a1f14",
              marginBottom: "0.15em",
            }}
          ></span>
          <br />
          the brim,
        </h1>
      </div>

      {/* editorial hero title - right half (moved to top-right) */}
      <div
        className="absolute z-40 text-right"
        style={{ right: "3vw", top: "14vh", maxWidth: "26vw", minWidth: "300px" }}
      >
        <p
          className="mb-6 font-mono-ui text-[12px] tracking-[0.2em]"
          style={{ color: "#4a3728" }}
        >
          &nbsp;A veil of pearls
        </p>
        <h1
          className="font-display font-normal"
          style={{
            color: "#2a1f14",
            fontSize: "clamp(48px, 6vw, 88px)",
            lineHeight: 0.98,
            letterSpacing: "-0.02em",
          }}
        >
          a curtain
          <br />
          of silk&nbsp;
          <span
            aria-hidden="true"
            className="inline-block align-middle"
            style={{
              width: "0.7em",
              height: "0.06em",
              backgroundColor: "#2a1f14",
              marginBottom: "0.15em",
            }}
          ></span>
        </h1>
      </div>

      {/* bottom-right editorial credit block */}
      <div
        className="absolute z-40 flex items-end gap-6"
        style={{ right: "3vw", bottom: "6vh" }}
      >
        <div className="flex flex-col gap-1 text-right font-mono-ui text-[10px] tracking-[0.28em] uppercase" style={{ color: "#4a3728" }}>
          <span>Photography &mdash; L. Moreau</span>
          <span>Styling &mdash; A. Nakamura</span>
          <span>Model &mdash; Ines V.</span>
        </div>
      </div>

      {/* bottom-left scroll cue */}
      <div
        className="absolute z-40 flex items-center gap-3"
        style={{ left: "3vw", bottom: "3vh" }}
      >
        <span
          className="block h-px"
          style={{ width: "56px", backgroundColor: "#2a1f14", opacity: 0.5 }}
        ></span>
        <span
          className="font-mono-ui text-[10px] tracking-[0.3em] uppercase"
          style={{ color: "#4a3728" }}
        >
          Scroll to unveil
        </span>
      </div>

      {/* decorative masthead strip */}
      <div
        className="absolute inset-x-0 z-40 px-8"
        style={{ top: "2vh" }}
      >
        {/* thin divider with center emblem */}
        <div className="flex items-center gap-4">
          <span
            className="block h-px flex-1"
            style={{ backgroundColor: "#2a1f14", opacity: 0.35 }}
          ></span>
          <span
            className="font-mono-ui text-[10px] tracking-[0.35em] uppercase"
            style={{ color: "#4a3728" }}
          >
            Edit N&deg; 01 &middot; Autumn 2026
          </span>
          <span
            className="block h-px flex-1"
            style={{ backgroundColor: "#2a1f14", opacity: 0.35 }}
          ></span>
        </div>

      </div>
    </div>
  );
}